export const FeatureName = 'notifications';
